import React, { useState, useEffect } from 'react';
import { OfflineStorage } from '../lib/offlineStorage';

const OfflineIndicator: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingUploads, setPendingUploads] = useState(0);

  useEffect(() => {
    const updatePendingCount = () => {
      setPendingUploads(OfflineStorage.getWorkoutCount());
    };

    const handleOnline = () => {
      setIsOnline(true);
      updatePendingCount();
    };

    const handleOffline = () => {
      setIsOnline(false);
      updatePendingCount();
    };

    const cleanup = OfflineStorage.setupConnectivityListeners(
      handleOnline,
      handleOffline
    );
    updatePendingCount();

    // Check for pending uploads periodically
    const interval = setInterval(updatePendingCount, 5000);

    return () => {
      cleanup();
      clearInterval(interval);
    };
  }, []);

  if (isOnline && pendingUploads === 0) {
    return null;
  }

  return (
    <div
      className={`fixed top-4 right-4 z-50 px-4 py-2 rounded-lg text-sm font-medium ${
        isOnline
          ? 'bg-yellow-100 text-yellow-800 border border-yellow-200'
          : 'bg-red-100 text-red-800 border border-red-200'
      }`}
    >
      {!isOnline && (
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-red-500 rounded-full"></div>
          <span>Offline Mode</span>
        </div>
      )}
      {isOnline && pendingUploads > 0 && (
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></div>
          <span>
            {pendingUploads} workout{pendingUploads !== 1 ? 's' : ''} pending
            upload
          </span>
        </div>
      )}
    </div>
  );
};

export default OfflineIndicator;
